(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var searchInput = document.getElementById('blog-search');
    var filterBtns = document.querySelectorAll('.blog-filter');
    var cards = document.querySelectorAll('#blog-articles .blog-card');
    var noResults = document.getElementById('blog-no-results');
    var activeFilter = 'all';
    var searchQuery = '';

    function applyFilters() {
      var visible = 0;
      cards.forEach(function(card) {
        var tags = card.getAttribute('data-tags') || '';
        var title = card.getAttribute('data-title') || '';
        var matchesFilter = activeFilter === 'all' || tags.indexOf(activeFilter) !== -1;
        var matchesSearch = searchQuery === '' || title.indexOf(searchQuery) !== -1;
        if (matchesFilter && matchesSearch) {
          card.classList.remove('blog-card--hidden');
          visible++;
        } else {
          card.classList.add('blog-card--hidden');
        }
      });
      if (noResults) noResults.style.display = visible === 0 ? 'block' : 'none';
    }

    filterBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        filterBtns.forEach(function(b) { b.classList.remove('blog-filter--active'); });
        btn.classList.add('blog-filter--active');
        activeFilter = btn.getAttribute('data-filter');
        applyFilters();
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', function() {
        searchQuery = searchInput.value.toLowerCase().trim();
        applyFilters();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var tabs = document.querySelectorAll('.collection-tab');
    var cards = document.querySelectorAll('#collection-products .collection-card');
    var noResults = document.getElementById('collection-no-results');
    var validTabs = ['all', 'book', 'essentials', 'downloads'];
    var requestedTab = new URLSearchParams(window.location.search).get('tab');
    var activeTab = validTabs.indexOf(requestedTab) !== -1 ? requestedTab : 'all';

    function applyTab() {
      var visible = 0;
      cards.forEach(function(card) {
        var tabGroup = card.getAttribute('data-tab') || 'other';
        if (activeTab === 'all' || tabGroup === activeTab) {
          card.classList.remove('collection-card--hidden');
          visible++;
        } else {
          card.classList.add('collection-card--hidden');
        }
      });
      if (noResults) noResults.style.display = visible === 0 ? 'block' : 'none';
    }

    tabs.forEach(function(tab) {
      if (tab.getAttribute('data-tab') === activeTab) {
        tabs.forEach(function(t) { t.classList.remove('collection-tab--active'); });
        tab.classList.add('collection-tab--active');
      }
      tab.addEventListener('click', function() {
        tabs.forEach(function(t) { t.classList.remove('collection-tab--active'); });
        tab.classList.add('collection-tab--active');
        activeTab = tab.getAttribute('data-tab');
        applyTab();
      });
    });

    applyTab();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function initCountdown(el) {
      var targetDate = new Date(el.dataset.target + 'T00:00:00');
      var daysEl = el.querySelector('[data-countdown-days]');
      var hoursEl = el.querySelector('[data-countdown-hours]');
      var minutesEl = el.querySelector('[data-countdown-minutes]');
      var secondsEl = el.querySelector('[data-countdown-seconds]');

      function tick() {
        var now = new Date();
        var diff = targetDate - now;
        if (diff <= 0) {
          daysEl.textContent = '00';
          hoursEl.textContent = '00';
          minutesEl.textContent = '00';
          secondsEl.textContent = '00';
          return;
        }
        daysEl.textContent = pad(Math.floor(diff / 86400000));
        hoursEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
        minutesEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
        secondsEl.textContent = pad(Math.floor((diff % 60000) / 1000));
      }

      tick();
      setInterval(tick, 1000);
    }

    document.querySelectorAll('[data-countdown]').forEach(initCountdown);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-capture"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.email-capture').forEach(function(section) {
      var confirm = section.querySelector('[data-email-capture-confirm]');
      var content = section.querySelector('[data-email-capture-content]');
      if (confirm && content && confirm.getAttribute('aria-hidden') === 'false') {
        content.style.display = 'none';
        section.scrollIntoView({ block: 'center' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["events"]) return;
  try {
    
  var rsvpWrap = document.querySelector('[data-rsvp]');
  if (rsvpWrap) {
    var btn = rsvpWrap.querySelector('[data-rsvp-btn]');
    var form = rsvpWrap.querySelector('[data-rsvp-form]');
    var confirm = rsvpWrap.querySelector('[data-rsvp-confirm]');
    btn.addEventListener('click', function() {
      form.style.display = 'none';
      confirm.setAttribute('aria-hidden', 'false');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  var hamburger = document.querySelector('.site-header__hamburger');
  var mobileNav = document.querySelector('.mobile-nav');
  var overlay = document.querySelector('.mobile-nav__overlay');
  var closeBtn = document.querySelector('.mobile-nav__close');

  function openNav() {
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeNav() {
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openNav);
  if (overlay) overlay.addEventListener('click', closeNav);
  if (closeBtn) closeBtn.addEventListener('click', closeNav);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeNav();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var priceEl = document.getElementById('pdp-price');
  var compareEl = document.getElementById('pdp-compare');
  var saveBadgeEl = document.getElementById('pdp-save-badge');
  var btnPriceEl = document.getElementById('pdp-btn-price');
  var addBtn = document.getElementById('pdp-add-btn');
  var qtyDisplay = document.getElementById('pdp-qty-display');
  var qtyInput = document.getElementById('pdp-qty-input');
  var mainImg = document.getElementById('pdp-main-img');
  var stickyEl = document.getElementById('pdp-sticky');
  var stickyPriceEl = document.getElementById('pdp-sticky-price');
  var stickyMetaEl = document.getElementById('pdp-sticky-meta');
  var stickyBtn = document.getElementById('pdp-sticky-btn');
  var ctaRow = document.getElementById('pdp-cta-row');

  var currentPrice = 0;
  var currentQty = 1;

  function cents(n) {
    return parseInt(n, 10) || 0;
  }

  function formatMoney(c) {
    return '$' + (c / 100).toFixed(2);
  }

  function updatePrice(price, comparePrice, available, variantTitle) {
    currentPrice = price;
    if (priceEl) priceEl.textContent = formatMoney(price);
    if (compareEl) {
      if (comparePrice > price) {
        compareEl.textContent = formatMoney(comparePrice);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (saveBadgeEl) {
      if (comparePrice > price) {
        var pct = Math.round((comparePrice - price) * 100 / comparePrice);
        saveBadgeEl.textContent = 'SAVE ' + pct + '%';
        saveBadgeEl.style.display = '';
      } else {
        saveBadgeEl.style.display = 'none';
      }
    }
    updateCartBtnLabel(available, price);
    if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(price);
    if (stickyMetaEl && variantTitle) stickyMetaEl.textContent = variantTitle;
  }

  function updateCartBtnLabel(available, price) {
    if (!addBtn) return;
    var total = price * currentQty;
    if (available) {
      addBtn.disabled = false;
      addBtn.classList.remove('pdp__add-btn--disabled');
      if (btnPriceEl) btnPriceEl.textContent = formatMoney(total);
    } else {
      addBtn.disabled = true;
      addBtn.classList.add('pdp__add-btn--disabled');
    }
  }

  document.querySelectorAll('.pdp__format-tile').forEach(function (tile) {
    var radio = tile.querySelector('.pdp__format-radio');
    if (!radio) return;
    radio.addEventListener('change', function () {
      document.querySelectorAll('.pdp__format-tile').forEach(function (t) { t.classList.remove('pdp__format-tile--active'); });
      tile.classList.add('pdp__format-tile--active');
      var price = cents(tile.dataset.price);
      var compare = cents(tile.dataset.compare);
      var available = tile.dataset.available === 'true';
      var variantName = tile.querySelector('.pdp__tile-name');
      updatePrice(price, compare, available, variantName ? variantName.textContent.trim() : '');
    });
    tile.addEventListener('click', function () {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  var initialTile = document.querySelector('.pdp__format-tile--active');
  if (initialTile) {
    currentPrice = cents(initialTile.dataset.price);
  }

  var minusBtn = document.querySelector('[data-qty-minus]');
  var plusBtn = document.querySelector('[data-qty-plus]');

  function setQty(n) {
    currentQty = Math.max(1, Math.min(99, n));
    if (qtyDisplay) qtyDisplay.textContent = currentQty;
    if (qtyInput) qtyInput.value = currentQty;
    updateCartBtnLabel(addBtn && !addBtn.disabled, currentPrice);
  }

  if (minusBtn) minusBtn.addEventListener('click', function () { setQty(currentQty - 1); });
  if (plusBtn) plusBtn.addEventListener('click', function () { setQty(currentQty + 1); });

  document.querySelectorAll('.pdp__thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (mainImg) {
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = btn.dataset.src;
        mainImg.alt = btn.dataset.alt || '';
      }
      document.querySelectorAll('.pdp__thumb').forEach(function (b) { b.classList.remove('pdp__thumb--active'); });
      btn.classList.add('pdp__thumb--active');
    });
  });

  document.querySelectorAll('.pdp__upsell-row').forEach(function (row) {
    row.addEventListener('click', function () {
      var pressed = row.getAttribute('aria-pressed') === 'true';
      row.setAttribute('aria-pressed', pressed ? 'false' : 'true');
      row.classList.toggle('pdp__upsell-row--active', !pressed);
    });
  });

  if (ctaRow && stickyEl) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var hidden = !entry.isIntersecting;
        stickyEl.classList.toggle('pdp-sticky--visible', hidden);
        stickyEl.setAttribute('aria-hidden', hidden ? 'false' : 'true');
      });
    }, { threshold: 0 });
    obs.observe(ctaRow);
  }

  if (stickyBtn && addBtn) {
    stickyBtn.addEventListener('click', function () {
      addBtn.click();
    });
  }

  var prevBtn = document.getElementById('pdp-xsell-prev');
  var nextBtn = document.getElementById('pdp-xsell-next');
  var track = document.getElementById('pdp-xsell-track');
  if (track && prevBtn && nextBtn) {
    var scrollAmt = function () { return track.clientWidth * 0.75; };
    prevBtn.addEventListener('click', function () { track.scrollBy({ left: -scrollAmt(), behavior: 'smooth' }); });
    nextBtn.addEventListener('click', function () { track.scrollBy({ left: scrollAmt(), behavior: 'smooth' }); });
  }

  var form = document.getElementById('pdp-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      var upsells = document.querySelectorAll('.pdp__upsell-row[aria-pressed="true"]');
      if (!upsells.length) return;
      e.preventDefault();
      var mainId = form.querySelector('[name="id"]');
      var qty = form.querySelector('[name="quantity"]');
      var items = [{ id: mainId ? mainId.value : '', quantity: qty ? parseInt(qty.value, 10) || 1 : 1 }];
      upsells.forEach(function (row) {
        var uid = row.dataset.upsellId;
        if (uid) items.push({ id: uid, quantity: 1 });
      });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function () {
        addBtn.textContent = '✓ Added to Cart!';
        addBtn.style.background = '#0D6B6E';
        setTimeout(function () {
          addBtn.textContent = 'Add to Cart';
          addBtn.style.background = '';
        }, 2200);
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  var prev = document.getElementById('sc-prev');
  var next = document.getElementById('sc-next');
  var track = document.getElementById('sc-track');
  if (!track || !prev || !next) return;
  var amt = function () { return track.clientWidth * 0.75; };
  prev.addEventListener('click', function () { track.scrollBy({ left: -amt(), behavior: 'smooth' }); });
  next.addEventListener('click', function () { track.scrollBy({ left: amt(), behavior: 'smooth' }); });
})();

  } catch(e) { console.error(e); }
})();
})();
